<template>
  <div class="life">
    <div class="bgColor"></div>
    <van-nav-bar title="生活服务" left-arrow @click-left="onClickLeft" />
    <div class="life-img">
      <div class="img-top" @click="toUrl1">
        <img :src="img1" />
        <div class="top-tit">
          <div class="Hei">今日天气</div>
          <!-- <div>查看未来</div> -->
        </div>
        <div class="weather" v-if="weather != ''">
          <div>
            <van-icon name="location" color="#FF8010" /> {{ weather[0].city }}
          </div>
          <div>{{ weather[0].weather }} {{ weather[0].temperature }}°C</div>
        </div>
      </div>
      <div class="img-top" v-if="img2 != ''" @click="toUrl">
        <img :src="img2" />
        <div class="top-tit">
          <div class="Hei">出行服务</div>
          <img src="@/assets/img/life/right.png" />
          <!-- <div>查看</div> -->
        </div>
      </div>
    </div>
    <div class="img-tit Hei">
      生活百科
      <!-- <img src="@/assets/img/life/tit.png" /> -->
    </div>
    <List />
  </div>
</template>
<script>
import AMapLoader from "@amap/amap-jsapi-loader";
// import AMap from "AMap";
import List from "../ideology/ideology";
import { getWeatherByAdCode, wechatApi, positionContent } from "@/api/apiData";
import { Toast } from "vant";
export default {
  components: { List },
  data() {
    return {
      weather: "",
      img1: "",
      img2: "",
      city: "",
      url2: "",
    };
  },
  mounted() {
    this.getMap();
    this.getTian();
    // this.getConfig();
    this.getImg();
  },
  methods: {
    getConfig() {
      wechatApi().then((res) => {
        if (res.code == 1) {
          wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "previewImage"],
            openTagList: ["wx-open-launch-weapp"], // 可选，需要使用的开放标签列表，例如[‘wx-open-launch-weapp’]
          });
          wx.error(function (res) {
            console.log(res);
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          });
        }
      });
    },
    toUrl() {
      if (this.url2 != "") {
        window.location.href = this.url2;
      }
    },
    toUrl1() {
      if (this.url1 != "") {
        window.location.href = this.url1;
      }
    },
    onClickLeft() {
      this.$router.push("/index");
    },
    // 显示定位地图以及获取当前经纬度地址
    getMap() {
      let that = this;
      AMapLoader.load({
        key: "73e5067aebb962c80e3a5dac310f3fef", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Geolocation", "AMap.Geocoder"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        AMapUI: {
          // 是否加载 AMapUI，缺省不加载
          version: "1.1", // AMapUI 缺省 1.1
          plugins: [], // 需要加载的 AMapUI ui插件
        },
      }).then((AMap) => {
        AMap.plugin("AMap.Geolocation", () => {
          var geolocation = new AMap.Geolocation({
            // 是否使用高精度定位，默认：true
            enableHighAccuracy: true,
            // 设置定位超时时间，默认：无穷大
            timeout: 10000,
          });

          geolocation.getCityInfo((status, result) => {
            //只能获取当前用户所在城市和城市的经纬度
            if (status == "complete") {
              console.log("result", result);
              if (result.city) {
                that.city = result.city;
                that.getTian();
              }
            }
          });
          geolocation.getCurrentPosition((status, result) => {
            //获取用户当前的精确位置
            if (status == "complete") {
              console.log("result", result);
            }
          });
        });
      });
    },
    getTian() {
      let city = this.city;
      if (city == "") {
        city = "南昌市";
      }
      getWeatherByAdCode({ extensions: "base", city: city }).then((res) => {
        this.weather = res.data;
      });
    },
    onComplete(data) {
      let that = this;
      // Toast("定位成功");
      let getposition = data.position;
      console.log(getposition.toString());
    },
    onError(data) {
      Toast("定位失败：" + data.message);
      //console.log(data.message);
    },
    // 获取图片
    getImg() {
      positionContent({ posid: 2 }).then((res) => {
        if (res.code == 1) {
          this.img1 = res.data[0].path;
          this.url1 = res.data[0].url;
        } else {
          Toast(res.msg);
        }
      });
      positionContent({ posid: 3 }).then((res) => {
        if (res.code == 1) {
          this.img2 = res.data[0].path;
          this.url2 = res.data[0].url;
        } else {
          Toast(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.life-img {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background: white;
  .img-top {
    // width: 48%;
    margin: 0 5px;
    flex: 1;
    position: relative;
    img {
      width: 100%;
      // height: 2rem;
      border-radius: 0.1rem;
    }
    .top-tit {
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      font-size: 0.3rem;
      display: flex;
      justify-content: space-between;
      color: #ffd736;
      font-weight: bold;
      background: rgba(33, 33, 33, 0.7);
      padding:0.2rem 0.3rem;
      align-items: center;
      img {
        width: 0.4rem;
        position: absolute;
        right: 0.2rem;
      }
    }
    .top-tit div:nth-child(1) {
      letter-spacing: 5px;
      line-height: 1;
    }
    .top-tit div:nth-child(2) {
      font-size: 0.2rem;
      color: white;
      line-height: 1;
      border-bottom: solid 1px;
    }
    .weather {
      position: absolute;
      font-size: 0.3rem;
      color: white;
      top: 0.2rem;
      left: 0.3rem;
      line-height: 1.8;
    }
  }
}
.img-tit {
  padding: 10px 20px;
  font-size: 20px;
  letter-spacing: 5px;
  img {
    width: 2rem;
  }
}
.bgColor {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  background: #f7f7f7;
}
</style>